var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "fav-link",
      class: { hasBeenSelected: _vm.favorites.indexOf(_vm.postId) !== -1 },
      attrs: { href: "javascript:void(0)" },
    },
    [
      _c("span", { staticClass: "empty" }, [
        _c("img", { attrs: { src: _vm.svgIconUrl + "esmark-hjerte.svg" } }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "full" }, [
        _c("img", {
          attrs: { src: _vm.svgIconUrl + "esmark-hjerte-fyldt.svg" },
        }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "text" }, [
        _vm._v(_vm._s(_vm.translations.sentences.addToFavorites)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }